import { Component, OnInit, EventEmitter, Output, Input, forwardRef, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormGroup, FormBuilder, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ax-edit-button',
  templateUrl: './edit-button.component.html',
  styleUrls: ['./edit-button.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditButtonComponent),
      multi: true,
    },
  ],
  host: {'class': 'ax-edit-button'}
})
export class EditButtonComponent implements OnInit, OnDestroy, ControlValueAccessor {

  model:FormGroup = this.fb.group({
    value: [null]
  });

  @Input()
  placeholder: string = 'Clique nas reticências para procurar o registro.';

  @Input()
  enabled: boolean = true;

  @Input()
  label: string | null = null;

  @Input()
  readonly: boolean = true;

  @Input()
  multiline: boolean = false;

  @Input()
  clearable: boolean = false;

  @Input()
  lines: number = 2;

  @Output()
  onClick: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onClear: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value: string | null = null;

  subs: Subscription | null = null;

  constructor(private fb: FormBuilder) { 
    
  }

  ngOnInit() {
  }

  onClicked() {
    if(!this.enabled)
      return;

    this.onClick.emit();
  }

  public focusIn(target: HTMLElement | null): void {
    if(target === null) throw 'target is null.';
    if(!this.enabled)
      return;

    target.parentElement?.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement | null): void {
    if(target === null) throw 'target is null.';
    if(!this.enabled) return;

    target.parentElement?.classList.remove('e-input-focus');
  }


  public onMouseDown(target: HTMLElement): void {
    if(!this.enabled)
      return;

    target.classList.add('e-input-btn-ripple');
  }

  public onMouseUp(target: HTMLElement): void {
    let ele: HTMLElement = target;
    setTimeout(
            () => {ele.classList.remove('e-input-btn-ripple'); },
            500);
  }

  writeValue(obj: any): void {
    this.model.get('value')?.setValue(obj, { emitEvent: false, onlySelf: true });
  }

  registerOnChange(fn: any): void {
    this.subs = this.model.get('value')?.valueChanges?.subscribe((x: any) => {
      fn(x);
    }) ?? null;
  }

  clear() {
    this.model.get('value')?.setValue(null);
    this.onClear.emit();
  }

  registerOnTouched(fn: any): void {
    
  }
  
  setDisabledState?(isDisabled: boolean): void {
    
  }

  ngOnDestroy(): void {
    if(this.subs)
      this.subs.unsubscribe();
  }

}
